// 3rd Party
import { JwtHelperService } from '@auth0/angular-jwt';

// Environment
import { environment } from 'environments/environment';

export class UserProfile {
    public uniqueName = ' ';
    public emailAddress = '';
    public fullName = '';
    public familyName = '';
    public givenName = '';
    public ipAddress = '';
    public roles: any;

    constructor(
        private jwtHelper: JwtHelperService = new JwtHelperService()
    ) {
        const userProfile = localStorage.getItem(environment.TokenName);
        const token = (userProfile == null) ? null : JSON.parse(userProfile)['token'];

        if (token) {
            const decodedToken = jwtHelper.decodeToken(token);

            this.uniqueName = decodedToken.unique_name;
            this.emailAddress = decodedToken.upn;
            this.fullName = decodedToken.name;
            this.familyName = decodedToken.family_name;
            this.givenName = decodedToken.given_name;
            this.ipAddress = decodedToken.ipaddr;
        }
    }
}
